import { loadingActions } from "@/store/reducers/loading";
import { useDispatch } from "react-redux";

export default function useLoading() {

    const dispatch = useDispatch();

    const show = (text: string): void => {
        dispatch(loadingActions.activate(text));
    }

    const hide = (): void => {
        dispatch(loadingActions.close());
    }

    return {
        show: show,
        hide: hide
    };

}